import factory from './icon';
import Svg24x24 from './Glyphs/User_24x24.svg';
import SvgFull24x24 from './Glyphs/UserFull_24x24.svg';

export const User24x24 = factory(Svg24x24, 24, 24);
export const UserFull24x24 = factory(SvgFull24x24, 24, 24);
